import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Built-in percent while the owner has never saved the setting
export const DEFAULT_PARTNER_CODE_PERCENT = 20;

export interface PartnerCodeSettingsHistoryItem {
  discount_percent: number;
  created_at: string;
  created_by: string | null;
}

export interface PartnerCodeSettings {
  discount_percent: number;
  // True while the owner has never saved the setting (the percent is the built-in 20)
  is_default: boolean;
  updated_at: string | null;
  updated_by: string | null;
  // Every change, newest first (at most 100)
  history: PartnerCodeSettingsHistoryItem[];
}

export interface PartnerCodeSettingsState {
  settings: PartnerCodeSettings | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: PartnerCodeSettingsState = {
  settings: null,
  loading: false,
  saving: false,
  error: null,
};

const partnerCodeSettingsSlice = createSlice({
  name: 'partnerCodeSettings',
  initialState,
  reducers: {
    setPartnerCodeSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPartnerCodeSettingsSaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload;
    },
    setPartnerCodeSettingsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setPartnerCodeSettings: (state, action: PayloadAction<PartnerCodeSettings>) => {
      state.settings = action.payload;
    },
  },
});

export const {
  setPartnerCodeSettingsLoading,
  setPartnerCodeSettingsSaving,
  setPartnerCodeSettingsError,
  setPartnerCodeSettings,
} = partnerCodeSettingsSlice.actions;

export default partnerCodeSettingsSlice.reducer;
